// Explore-stats page: Periods of service — current Parliament.
// Recreates the Handbook page — a bubble per current parliamentarian
// sized by years of service, with a name/party/state/years table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatBubble } from './charts';

export default function PeriodsOfService() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('periods-of-service');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Periods of service — current Parliament"
      description={`Each current parliamentarian shown as a bubble — the larger the bubble, the longer they have served${
        charts.total ? ` (${charts.total} parliamentarians)` : ''
      }.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="periods-of-service"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Periods of service — current Parliament
          </Typography>
          <StatBubble data={charts.bubbles || []} zKey="years" />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
